(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-user-practice-select-view', [
      'kareo.ui.shared.directives.templates',
      'ngTagsInput'
    ])
    .component('kUserPracticeSelectView', {
      bindings: {
        choices: '<', // array of practices with {name, practiceGuid}
        selections: '=',
        currentPracticeGuid: '<'
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-user-practice-select-view.pug')()
    });

  controller.$inject = ['$filter', '$q'];
  function controller($filter, $q) {
    const vm = this;

    vm.currentPracticeGuid = vm.currentPracticeGuid || '';
    vm.getSources = getSources;

    // -------------------------------------------------------------------------

    function getSources(query) {
      return $q.when($filter('filter')(vm.choices, { name: query }, false));
    }
  }
})();
